// import storage from "redux-persist/lib/storage";
import {persistReducer} from "redux-persist";
import * as actionTypes from '../actions/actionTypes';
import localForage from 'localforage';

const initialState = {
    companies: undefined,
    modules: undefined,
    timezones : undefined,
    current_module: 'default',
    current_company: null, // null - None
    current_office: null, // 0 - All Offices
    all_companies: false,
};

const sessionReducer = persistReducer(
    {
        storage: localForage,
        key: "od-session",
        whitelist: ["companies", "modules", "timezones", "current_module", "current_company", "current_office", "all_companies"]
    },
    (state = initialState, action) => {
        switch (action.type) {
            case actionTypes.SET_CURRENT_COMPANY_SESSION: {
                const {current_company, current_office, all_companies} = action.payload;
                return {
                    ...state,
                    current_company,
                    current_office,
                    all_companies
                };
            }

            case actionTypes.FULLFILL_USER_SETTINGS: {
                const {companies, modules} = action.payload;
                return {
                    ...state,
                    companies,
                    modules
                };
            }

            case actionTypes.TIMEZONES_FETCH_SUCCEEDED: {
                const {timezones} = action.payload;
                return {
                    ...state,
                    timezones
                };
            }

            case actionTypes.AUTH_LOGOUT: {
                return { companies: undefined, modules: undefined };
            }

            default:
                return state;
        }
    }
);

export default sessionReducer;
